import { WalletCurrencyType } from 'api/Trading-Accounts/Types/WalletCurrencyType'

import { multiSelectFilterCell } from './MultiSelectFilterCell'

export const CurrenciesFilterCell = multiSelectFilterCell({
  items: Object.keys(WalletCurrencyType).map((x) => ({ id: x, value: x, label: x })),
  options: {
    operator: '==',
  },
})
